import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import LegalLayout from './LegalLayout';

const tokushohoContent = `
# 特定商取引法に基づく表記

| 項目 | 内容 |
| --- | --- |
| 販売事業者 | 合同会社 レインバレーズ |
| 代表者 | 雨ヶ谷恵 |
| 所在地 | 〒389-0111 長野県北佐久郡軽井沢町2115-1188 |
| 連絡先 | info@mqgauss.com（お問い合わせはメールにて受け付けます。電話番号は、ご請求があれば遅滞なく開示します） |
| 販売価格 | 各プラン・クレジットパックの購入画面に税込価格で表示します。月額プラン: Light 500円／Standard 1,200円／Deep 2,500円（税込・各月次クレジット付与）。クレジットパック: Small 300円／Medium 1,000円／Large 2,000円（税込）。 |
| 商品代金以外の必要料金 | インターネット接続料金・通信料金等はお客様のご負担となります。 |
| 支払方法 | クレジットカード（決済代行: Stripe） |
| 支払時期 | 月額プランは申込時に当月分を決済し、以後は毎月の更新日に自動で決済します。クレジットパックは購入時に決済します。 |
| 商品の引渡時期 | 決済完了後ただちに、アカウントへクレジットを付与し、対象機能を利用可能にします。 |
| 定期購入（自動更新）について | 月額プランは、解約のお手続きがない限り、各更新日に同一料金で自動更新されます。更新日・金額・解約方法は購入確定前の画面に表示します。 |
| 解約・キャンセル | 月額プランは、管理画面（カスタマーポータル）からいつでも解約できます。解約後も当該請求期間の終了日まで利用でき、次回更新からの請求は発生しません。プラン変更は次回更新時に反映されます。 |
| 返品・返金について | 役務・デジタルコンテンツの性質上、購入後の返金は原則としてお受けできません。月額プランは解約後も期間末まで利用可能です。クレジットパックは購入から90日で失効します。 |
| 動作環境 | 最新版の主要Webブラウザ。 |

最終更新日: 2026年6月7日
`;

export default function SpecifiedCommercialTransactions() {
  return (
    <LegalLayout>
      <div className="markdown-body">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {tokushohoContent}
        </ReactMarkdown>
      </div>
    </LegalLayout>
  );
}
